
import Vue from 'vue'
// import { mapGetters } from 'vuex'

import PlantAvatar from '@/ui/components/plants/PlantAvatar.vue'
import Plant from '@/models/Plant'

// import PlantInfoDashboard from '@/ui/components/plants/dashboard/PlantInfoDashboard.vue'
// import PlantHarvests from '@/ui/components/plants/fragments/PlantHarvests.vue'
// import PlantTimeline from '@/ui/components/plants/fragments/PlantTimeline.vue'
// import PlantImageGallery from '@/ui/components/plants/fragments/PlantImageGallery.vue'
// import PlantUploadAvatar from '@/ui/components/plants/fragments/PlantUploadAvatar.vue'

export default Vue.extend({
  components: {
    PlantAvatar,

    // PlantInfoDashboard,
    // PlantHarvests,
    // PlantTimeline,
    // PlantImageGallery,

    // PlantUploadAvatar,
  },
  props: {
    gardenId: String,
    plantId: String,
    tab: String,
  },
  data: () => ({
    readonly: true,
    showScrollToTop: false,
  }),
  computed: {
    plant(): Plant {
      // console.log(this.gardenId, this.plantId);
      return this.$store.getters['gardens/plants/find'](this.plantId)
    },
    // calcTab(): string {
    //   return this.tab || 'dashboard'
    // },
    isInitialized(): boolean {
      return this.$store.state.gardens.isInitialized
    },
  },
  methods: {
    onScroll() {
      if (typeof window === 'undefined') return
      const top = window.pageYOffset || 0 // || e.target?.scrollTop || 0
      this.showScrollToTop = top > 48
    },
    toTop() {
      this.$vuetify.goTo(0)
    },
  },
})
